
const DirectiveEntryExecutionEntryAwaitingClientReview = () => {
  return (
    <p className="text-warning text-right">
      Aguardando vistoria
    </p>
  );
}

export default DirectiveEntryExecutionEntryAwaitingClientReview;
